import { CheckOutlined, CloseOutlined, ExclamationOutlined } from '@ant-design/icons';
import { Radio } from 'antd';

interface IProps {
  value?: 'Success' | 'Warning' | 'Failure' | null;
  onChange?: (e: any) => void;
}

export const StatusRadioGroup: React.FC<IProps> = ({ value, onChange }) => {
  const iconStyle = { fontSize: 25, fontWeight: 'bold' };
  const options = [
    { value: 'Success', icon: <CheckOutlined style={iconStyle} />, color: '#52c41a' },
    { value: 'Warning', icon: <ExclamationOutlined style={iconStyle} />, color: '#faad14' },
    { value: 'Failure', icon: <CloseOutlined style={iconStyle} />, color: '#ff4d4f' },
  ];

  return (
    <Radio.Group
      value={value}
      onChange={onChange}
      style={{ display: 'flex', gap: 12 }}
      className="no-radio-group-border"
    >
      {options.map((opt) => {
        const isActive = value === opt.value;
        return (
          <Radio.Button
            key={opt.value}
            value={opt.value}
            style={
              {
                backgroundColor: isActive ? opt.color : '#f5f5f5',
                color: isActive ? '#fff' : opt.color,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 50,
                height: 35,
                borderRadius: 12,
                fontSize: 22,
                marginLeft: 0,
                borderWidth: 2,
                borderStyle: 'solid',
                borderColor: `${opt.color} !important`,
              } as React.CSSProperties
            }
          >
            {opt.icon}
          </Radio.Button>
        );
      })}
      <style>
        {`
          .no-radio-group-border .ant-radio-group {
            border: none !important;
            box-shadow: none !important;
          }
          .no-radio-group-border .ant-radio-button-wrapper {
            border: none !important;
            box-shadow: none !important;
          }
          .no-radio-group-border .ant-radio-button-wrapper:not(:first-child)::before {
            display: none !important;
          }
          .no-radio-group-border .ant-radio-button-wrapper {
            border-width: 2px !important;
          }
        `}
      </style>
    </Radio.Group>
  );
};
